import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { useAppDialog } from "../../store/app-dialog";
import { DialogActions, DialogContent, Fab } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import l10n from "../../lib/l10n";
import { useCropperAction } from "@src/v3.0.0/store/cropper/cropper-actions";

function ActionsTool() {
  const { dispatch: dispatchCropperAction } = useCropperAction();
  const { closeDialog, invokeDialog } = useAppDialog();

  const onClickResetCropper = async (e) => {
    try {
      await invokeDialog((resolve, reject, onClose) => (
        <>
          <DialogContent>
            <div dangerouslySetInnerHTML={{ __html: l10n.wppr_cjs_ctrl_reset_text }} />
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose} startIcon={<CloseIcon />}>ANNULLA</Button>
            <Button onClick={() => resolve()} startIcon={<CheckIcon />} variant="outlined">CONFERMA</Button>
          </DialogActions>
        </>
      ), { title: 'Reimpostare la stampa?', type: useAppDialog.WARN });
    } catch(e) {
      return;
    }

    closeDialog();
    dispatchCropperAction({ zeroAll: null });
  };

  const onClickUndo = () => {
  }
  
  const onClickRedo = () => {
  }

  return (
    <>
      {l10n.wppr_cjs_ctrl_history_active === "yes" && (
        <>
          <Tooltip title="Indietro" placement="top">
            <Fab onClick={onClickUndo}>
              <UndoIcon />
            </Fab>
          </Tooltip>
          <Tooltip title="Avanti" placement="top">
            <Fab onClick={onClickRedo}>
              <RedoIcon />
            </Fab>
          </Tooltip>
        </>
      )}
      {l10n.wppr_cjs_ctrl_reset_active === "yes" &&(
        <Tooltip title="Da capo" placement="top">
          <Fab onClick={onClickResetCropper}>
            <RestartAltIcon />
          </Fab>
        </Tooltip>
      )}
    </>
  );
};

export default ActionsTool;